import { Component, OnInit } from "@angular/core";
import { Product } from "../../models/product";
import { ProductService } from "../../services/product.service";
import { ActivatedRoute, Router } from "@angular/router";
import { UNITS, Price } from "../../models/price";
import { Seo } from "../../models/api/seo.model";
import { CartService } from "../../services/cart.service";
import { SEOService } from "../../services/seo.service";
import { MetaTag } from "../../models/metaTag";
import { PropertyTag } from "../../models/api/propertyTag.model";
import { Item } from "../../models/item";
import { Quantity } from "../../models/quantity";
import Swal from "sweetalert2";
import { Contact } from "../../models/api/contact";
import { HttpErrorResponse } from "@angular/common/http";
import { ApiService } from "../../services/api.service";

@Component({
  selector: "app-product",
  templateUrl: "./product.component.html",
  styleUrls: ["./product.component.scss"],
})
export class ProductComponent implements OnInit {
  product: Product = new Product();
  products: Product[] = [];
  allProducts: Product[] = [];
  topProducts: Product[] = [];
  relatedProducts: Product[] = [];
  contact: Contact = new Contact();
  categories: string[] = new Array();
  isLoading = false;
  buttonMsg = "Submit Comment";
  units = UNITS;
  chosenUnit: string = UNITS[0].name;
  currentPrice = "";
  searchString = "";
  quant: number = 1;
  rand50_100: number;
  tags = new Array();
  properties = new Array();
  seo = new Seo();
  keyUp = "";
  schema;

  products2: Product[];
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private productService: ProductService,
    private cartService: CartService,
    private seoService: SEOService,
    private apiService: ApiService
  ) { }

  ngOnInit() {
    this.rand50_100 = Math.floor(Math.random() * (100 - 50 + 1)) + 50;
    this.route.params.subscribe((params) => {
      let id: string = params["id"];
      this.product = this.productService.find(id);
      this.chosenUnit = this.product.prices[0].unit;
      this.products = this.productService.findRandomAndExclude(4, id);
      this.allProducts = this.productService.findAllCategories();
      this.relatedProducts = this.productService
        .findAll()
        .filter(
          (p) => p.category == this.product.category && p != this.product
        );
      // this.getTopProducts();
      if (!this.product) {
        this.router.navigate(["/"]);
      }
    });
    this.currentPrice =
      this.product.prices[0].amount + " / " + this.product.prices[0].unit;

    this.setCategories();
  }

  addToCart2(product) {
    this.chosenUnit = product.prices[0].unit;
    if (this.keyUp) this.quant = parseFloat(this.keyUp);
    if (this.chosenUnit && Number.isFinite(this.quant) && !(this.quant <= 0)) {
      let item: Item = new Item();
      let quant: Quantity = new Quantity();
      quant.quantity = this.quant;
      quant.unit = this.chosenUnit;
      item.product = product;
      item.quantity = quant;
      this.cartService.add(item);
    } else {
      this.quant = 1;
      Swal({
        title: "Bad Quantity",
        text: "Please enter a non zero quantity value to proceed",
        type: "warning",
        confirmButtonText: "Ok got it!",
        confirmButtonColor: "#07a763",
      });
    }
  }

  addToCart() {
    if (this.keyUp) this.quant = parseFloat(this.keyUp);
    if (this.chosenUnit && Number.isFinite(this.quant) && !(this.quant <= 0)) {
      let item: Item = new Item();
      let quant: Quantity = new Quantity();
      quant.quantity = this.quant;
      quant.unit = this.chosenUnit;
      item.product = this.product;
      item.quantity = quant;
      this.cartService.add(item);
    } else {
      this.quant = 1;
      Swal({
        title: "Bad Quantity",
        text: "Please enter a non zero quantity value to proceed",
        type: "warning",
        confirmButtonText: "Ok got it!",
        confirmButtonColor: "#07a763",
      });
    }
  }

  submit() {
    this.contact.subject = "Review for " + this.product.name;
    this.buttonMsg = "Submitting...";
    this.apiService.contact(this.contact).subscribe(
      (data: any) => {
        this.isLoading = true;
        Swal({
          title: "Thanks!",
          text: "Thank you for your opinion on this product! Your comment will be forwarded.",
          type: "success",
          confirmButtonText: "Ok",
          confirmButtonColor: "#07a763",
        });
        this.contact = new Contact();
        this.isLoading = false;
        this.buttonMsg = "Submit Comment";
      },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        Swal({
          title: "Error!",
          text: "Unable to submit comment. Make sure you are connected to the internet",
          type: "warning",
          confirmButtonText: "Ok got it!",
          confirmButtonColor: "#07a763",
        });
        this.buttonMsg = "Submit Comment";
      }
    );
  }

  addQuant() {
    if (this.keyUp) {
      this.quant = parseFloat(this.keyUp);
      this.keyUp = "";
    }
    this.quant += 1;
  }

  reduceQuant() {
    if (this.keyUp) {
      this.quant = parseFloat(this.keyUp);
      this.keyUp = "";
    }
    if (this.quant - 1 <= 0) this.quant = 0;
    else this.quant -= 1;
  }

  onQuantityChange(value: string) {
    this.keyUp = value;
  }

  hasManyOptions(product: Product) {
    console.log(product.prices.length);
    return product.prices.length > 4 ? true : false;
  }

  getFourPrices(product: Product): Price[] {
    let prices: Price[] = new Array();
    for (let i = 0; i < 4; i++) {
      prices.push(product.prices[i]);
    }
    return prices;
  }

  // getProductStars(product: Product) {
  //   let stars = 0;
  //   if (product.comments.length <= 0) {
  //     return product.stars;
  //   } else {
  //     for (var i = 0; i < product.comments.length; i++) {
  //       stars += product.comments[i].stars;
  //     }
  //     if (stars > 100) {
  //       return 90;
  //     } else {
  //       return Math.ceil(stars / product.comments.length);
  //     }
  //   }
  // }

  getCategroyCount(category: string) {
    let count = 0;
    this.productService.findByCategory(category).forEach((product) => {
      if (product.category.toLowerCase() === category.toLowerCase()) {
        count++;
      }
    });
    return count;
  }

  // getTopProducts() {
  //   this.topProducts = new Array();
  //   this.productService.findAllCategories().forEach((p) => {
  //     if (p.stars >= 80 && this.topProducts.length <= 4) {
  //       this.topProducts.push(p);
  //     }
  //   });
  // }

  search() {
    if (this.searchString !== "") {
      this.router.navigate(["search/" + this.searchString.replace(" ", "+")]);
    }
  }

  setCategories() {
    this.allProducts.forEach((p) => {
      if (
        !this.categories.includes(p.category.toLowerCase()) &&
        p.category != ""
      ) {
        this.categories.push(p.category.toLowerCase());
      }
    });
  }

  getCurrentPrice() {
    if ((this.chosenUnit = "")) {
      this.currentPrice =
        this.product.prices[0].amount + " / " + this.product.prices[0].unit;
    } else {
      this.product.prices.forEach((p) => {
        if (p.unit == this.chosenUnit) {
          this.currentPrice = p.amount + " / " + p.unit;
        }
      });
    }
  }
}
